import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getinspectreports: option =>
    request('v1/inspect/getinspectreports', option, true, false), // 查询报检单信息列表
  getinspectreport: option => {
    const urls = querystring(option)
    return request('v1/inspect/getinspectreport' + urls, {}, true, false) // 查询报检单信息
  },
  addinspectreport: option =>
    request('v1/inspect/addinspectreport', option, true, false), // 新增报检单信息
  updateinspectreport: option =>
    request('v1/inspect/updateinspectreport', option, true, false), // 修改报检单信息
  deleteinspectreport: option => {
    const urls = querystring(option)
    return request('v1/inspect/deleteinspectreport' + urls, {}, true, false) //  删除报检单信息
  },
  recallinspectreport: option =>
    request('v1/inspect/recallinspectreport', option, true, false), //  紧急召回
  applyauditinspectreport: option => {
    const urls = querystring(option)
    return request('v1/inspect/applyauditinspectreport' + urls, {}, true) //  报检单提交审核
  },
  cancelauditinspectreport: option => {
    const urls = querystring(option)
    return request('v1/inspect/cancelauditinspectreport' + urls, {}, true) //  撤销要审核报检单
  },
  auditinspectreport: option =>
    request('v1/inspect/auditinspectreport', option, true, false) //   审核报检单
}
